import { VariableInput } from "./VariableInput";
import { VariableList } from "./VariableList";

export const VariableTab: React.FC = () => (
	<>
		<VariableInput />
		<VariableList />
	</>
);
